import { FC } from 'react';
import * as React from 'react';
import { HTMLWrapperContainer } from './HTMLWrapperEntry.styles';

export type Props = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    nodeData: Record<string, any>;
    type?: string;
};

const HTMLWrapperEntry: FC<React.PropsWithChildren<Props>> = ({ nodeData }) => {
    const type = nodeData.data?.target?.fields.type;
    const html = { __html: nodeData.data?.target.fields.code };
    const entryId = nodeData.data?.target.sys.id;

    if (type === 'Banner') {
        // Banners are just raw HTML that will be open-coded into the page
        // (whereas "Data Visualisation" and other types, handled below, are
        // <iframe>s that need a wrapper and an aspect ratio)
        return (
            <HTMLWrapperContainer
                data-testid={`banner-${entryId}`}
                dangerouslySetInnerHTML={html}
            />
        );
    }

    const aspectRatioBox = {
        '--aspect-ratio': '815/419'
    } as React.CSSProperties;

    return (
        <HTMLWrapperContainer>
            <div
                style={aspectRatioBox}
                data-testid={`iframe-${entryId}`}
                dangerouslySetInnerHTML={html}
            />
        </HTMLWrapperContainer>
    );
};

export default HTMLWrapperEntry;
